// extracted by mini-css-extract-plugin
export default {"isInitialized":"App_isInitialized__-xIBR"};